import React from "react";
import styled from "styled-components";
import { pulseDarker } from "../tables/LoadingTableCell";

const Placeholder = styled.span<{
  $height: number;
  $width: string;
}>`
  display: inline-block;
  vertical-align: middle;
  width: ${({ $width }): string => $width};
  height: ${({ $height }): number => $height}px;
  border-radius: 3px;
  animation: ${pulseDarker} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

export interface InlineLoadingPlaceholderProps {
  height?: number;
  label?: string;
  width?: string;
}

export const InlineLoadingPlaceholder = ({
  height = 12,
  label = "Loading",
  width = "160px",
}: InlineLoadingPlaceholderProps): JSX.Element => (
  <Placeholder
    $height={height}
    $width={width}
    aria-label={label}
    role="status"
  />
);
